// @flow
import type { BagItem, ShoppingCartItem } from '../../../entities';
import type { ItemsByStore } from './components/QuoteSummary/QuoteSummary';

type Item = ShoppingCartItem | BagItem;

const _groupItemsByStore = (items: Item[]) => items.reduce((acum: ItemsByStore[], item: Item, index: number) => {
  const i = acum.findIndex((x: ItemsByStore) => x.slug === item.onlineStore.slug);
  if (i === -1) {
    const newStore: ItemsByStore = {
      id: item.onlineStore.id,
      name: item.onlineStore.name,
      slug: item.onlineStore.slug,
      logo: item.onlineStore.logo,
      items: [{ ...item, index: index }],
    };
    return [...acum, { ...newStore }];
  }
  const store: ItemsByStore = {
    id: item.onlineStore.id,
    name: item.onlineStore.name,
    slug: item.onlineStore.slug,
    logo: item.onlineStore.logo,
    items: [...acum[i].items, { ...item, index: index }],
  };
  const newAcum = [...acum];
  newAcum[i] = store;
  return [...newAcum];
}, []);

export const groupItems = (items: Item[]): ItemsByStore[] => {
  // We check the first item for `onlineStore`, if it doesn't have one we return all items
  // with empty properties but items.
  if (!!items[0] && !!items[0].onlineStore) {
    return _groupItemsByStore(items);
  } else {
    return [{
      id: '',
      name: '',
      slug: '',
      logo: '',
      items: items,
    }]
  }
};

// This 2 params, must be parallel
export const hasChangedAmountOrShipping = (a: Item[], b: Item[]): boolean => {
  if (a.length !== b.length) return true;
  for (let i = 0; i < a.length; i++) {
    if (a[i].shipping !== b[i].shipping || a[i].amount !== b[i].amount) {
      return true;
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/utils.js